import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5aaa1dc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-layout" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "container-fluid" }
const _hoisted_4 = { class: "card card-flex card-outline card-themes" }
const _hoisted_5 = { class: "card-header" }
const _hoisted_6 = { class: "btn-group" }
const _hoisted_7 = { class: "card-tools" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("导出报表")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("导出明细")
const _hoisted_10 = { class: "btn-group float-right mr-2 hidden-xs" }
const _hoisted_11 = { class: "card-body table-responsive p-0" }
const _hoisted_12 = {
  key: 0,
  class: "table table-striped table-head-fixed table-width-auto text-nowrap text-center"
}
const _hoisted_13 = { ref: "tableTr" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "id" }, "ID", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "操作", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "ortTypeName" }, "组织类型", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "orgCode" }, "组织代码", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "orgName" }, "所属组织", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "deptName" }, "部门名称", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "assigneeUser.title" }, "姓名", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "processTotal" }, "总流程数", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "total" }, "总任务数", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "totalTimeName" }, "总处理用时", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  field: "avgTimeName",
  class: "normal-width text-left"
}, "任务平均用时", -1))
const _hoisted_25 = [
  _hoisted_14,
  _hoisted_15,
  _hoisted_16,
  _hoisted_17,
  _hoisted_18,
  _hoisted_19,
  _hoisted_20,
  _hoisted_21,
  _hoisted_22,
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = { key: 0 }
const _hoisted_27 = ["colspan"]
const _hoisted_28 = /*#__PURE__*/_createTextVNode("暂无数据")
const _hoisted_29 = { class: "table-btn-group" }
const _hoisted_30 = { class: "btn-group" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "text-left" }
const _hoisted_33 = {
  key: 0,
  class: "overlay hyper-text-themes animate__animated animate__fadeIn"
}
const _hoisted_34 = { class: "content-modal" }
const _hoisted_35 = { class: "table table-striped table-head-fixed table-width-auto text-nowrap text-center" }
const _hoisted_36 = { ref: "tableTr1" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "id" }, "ID", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "taskName" }, "任务名称", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "processStatusName" }, "流程状态", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "assigneeUser.title" }, "处理人", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "workCode" }, "工单编号", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "workSubject" }, "工单主题", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "fromOrgTypeIdName" }, "组织类型", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "fromOrgCode" }, "组织代码", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "fromOrgName" }, "所属组织", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "projectIdName" }, "所属设备", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "businessIdName" }, "故障类型", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "influenceIdName" }, "影响范围", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "workStar" }, "工单星级", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "taskCreatedTime" }, "开始时间", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "endTime" }, "结束时间", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "nodeDuration" }, "节点用时", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "workDescribeLaunch" }, "故障简述", -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  field: "comments",
  class: "normal-width text-left"
}, "处理意见", -1))
const _hoisted_55 = [
  _hoisted_37,
  _hoisted_38,
  _hoisted_39,
  _hoisted_40,
  _hoisted_41,
  _hoisted_42,
  _hoisted_43,
  _hoisted_44,
  _hoisted_45,
  _hoisted_46,
  _hoisted_47,
  _hoisted_48,
  _hoisted_49,
  _hoisted_50,
  _hoisted_51,
  _hoisted_52,
  _hoisted_53,
  _hoisted_54
]
const _hoisted_56 = { class: "text-left" }

export function render(_ctx, _cache) {
  const _component_app_content_header = _resolveComponent("app-content-header")
  const _component_svg_icon = _resolveComponent("svg-icon")
  const _component_app_dropdown_button = _resolveComponent("app-dropdown-button")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_app_modal = _resolveComponent("app-modal")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_app_content_header),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_ctx.Auth('/aftersale/report/work/efficiency/userEfficiency/add'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-themes",
                    onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.addModalOpen && _ctx.addModalOpen(...args)))
                  }, [
                    _createVNode(_component_svg_icon, { name: "add" })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_7, [
              (_ctx.Auth('/aftersale/report/work/efficiency/userEfficiency/list'))
                ? (_openBlock(), _createBlock(_component_app_dropdown_button, {
                    key: 0,
                    ref: "tableSearch",
                    searchFunction: _ctx.searchFunction,
                    disabledTableExport: !_ctx.Auth('/aftersale/report/work/efficiency/userEfficiency/export')
                  }, {
                    "dropdown-button-menu": _withCtx(() => [
                      _createElementVNode("li", {
                        class: "dropdown-item hand",
                        onClick: _cache[1] || (_cache[1] = $event => (_ctx.tableExportFunction('report')))
                      }, [
                        _createVNode(_component_svg_icon, {
                          name: "log-out-outline",
                          class: "mr-2"
                        }),
                        _hoisted_8
                      ]),
                      _createElementVNode("li", {
                        class: "dropdown-item hand",
                        onClick: _cache[2] || (_cache[2] = $event => (_ctx.tableExportFunction('detail')))
                      }, [
                        _createVNode(_component_svg_icon, {
                          name: "list",
                          class: "mr-2"
                        }),
                        _hoisted_9
                      ])
                    ]),
                    _: 1
                  }, 8, ["searchFunction", "disabledTableExport"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.tableRequestItem.dateTime,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.tableRequestItem.dateTime) = $event)),
                type: "datetimerange",
                shortcuts: _ctx.dateTimeShortcuts,
                size: "large",
                "range-separator": "至",
                "start-placeholder": "开始时间",
                "end-placeholder": "结束时间",
                "value-format": "YYYY-MM-DD HH:mm:ss",
                style: {"height":"calc(2.25rem + 2px)"},
                onChange: _cache[4] || (_cache[4] = $event => (_ctx.searchFunction('search')))
              }, null, 8, ["modelValue", "shortcuts"])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            (_ctx.Auth('/aftersale/report/work/efficiency/userEfficiency/list'))
              ? (_openBlock(), _createElementBlock("table", _hoisted_12, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", _hoisted_13, _hoisted_25, 512)
                  ]),
                  _createElementVNode("tbody", null, [
                    (_ctx.tableItems.length<1)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_26, [
                          _createElementVNode("td", {
                            colspan: _ctx.getTableTrLength(_ctx.$refs.tableTr)
                          }, [
                            _createVNode(_component_svg_icon, { name: "alert" }),
                            _hoisted_28
                          ], 8, _hoisted_27)
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableItems, (item, i) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: item.statusId,
                        class: _normalizeClass({'text-red': parseInt(item.statusStatus)===2})
                      }, [
                        _createElementVNode("td", null, _toDisplayString(((_ctx.tablePageItems.current-1) * _ctx.tablePageItems.size) + i + 1), 1),
                        _createElementVNode("td", _hoisted_29, [
                          _createElementVNode("div", _hoisted_30, [
                            (_ctx.Auth('/aftersale/report/work/efficiency/userEfficiency/detail'))
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  type: "button",
                                  class: "btn btn-themes",
                                  onClick: $event => (_ctx.detailModalOpen(item))
                                }, [
                                  _createVNode(_component_svg_icon, { name: "settings-outline" })
                                ], 8, _hoisted_31))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("td", null, _toDisplayString(item.orgTypeIdName), 1),
                        _createElementVNode("td", null, _toDisplayString(item.orgCode), 1),
                        _createElementVNode("td", null, _toDisplayString(item.orgName), 1),
                        _createElementVNode("td", null, _toDisplayString(item.deptName), 1),
                        _createElementVNode("td", null, _toDisplayString(item.assigneeUser.title), 1),
                        _createElementVNode("td", null, _toDisplayString(item.processTotal), 1),
                        _createElementVNode("td", null, _toDisplayString(item.total), 1),
                        _createElementVNode("td", null, _toDisplayString(item.totalTimeName), 1),
                        _createElementVNode("td", _hoisted_32, _toDisplayString(item.avgTimeName), 1)
                      ], 2))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                _createVNode(_component_svg_icon, {
                  name: "ali-loading",
                  size: "xl",
                  class: "turn"
                })
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_34, [
      _createVNode(_component_app_modal, {
        ref: "detailModal",
        title: _ctx.detailModalTitle,
        tableResponsive: true,
        noPadding: true,
        size: "xl",
        submitAfterClose: true
      }, {
        default: _withCtx(() => [
          _createElementVNode("table", _hoisted_35, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_36, _hoisted_55, 512)
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailItem, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key:  'taskDetail' + index
                }, [
                  _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                  _createElementVNode("td", null, _toDisplayString(item.taskName), 1),
                  _createElementVNode("td", null, _toDisplayString(item.processStatusName), 1),
                  _createElementVNode("td", null, _toDisplayString(item.assigneeUser.title), 1),
                  _createElementVNode("td", null, _toDisplayString(item.workCode), 1),
                  _createElementVNode("td", null, _toDisplayString(item.workSubject), 1),
                  _createElementVNode("td", null, _toDisplayString(item.fromOrgTypeIdName), 1),
                  _createElementVNode("td", null, _toDisplayString(item.fromOrgCode), 1),
                  _createElementVNode("td", null, _toDisplayString(item.fromOrgName), 1),
                  _createElementVNode("td", null, _toDisplayString(item.projectIdName), 1),
                  _createElementVNode("td", null, _toDisplayString(item.businessIdName), 1),
                  _createElementVNode("td", null, _toDisplayString(item.influenceIdName), 1),
                  _createElementVNode("td", null, _toDisplayString(item.workStar), 1),
                  _createElementVNode("td", null, _toDisplayString(item.taskCreatedTime), 1),
                  _createElementVNode("td", null, _toDisplayString(item.endTime), 1),
                  _createElementVNode("td", null, _toDisplayString(item.nodeDuration), 1),
                  _createElementVNode("td", null, _toDisplayString(item.workDescribeLaunch), 1),
                  _createElementVNode("td", _hoisted_56, _toDisplayString(item.comments), 1)
                ]))
              }), 128))
            ])
          ])
        ]),
        _: 1
      }, 8, ["title"])
    ])
  ]))
}